var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#19bcfe",
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 24c2.209139 0 4-1.790861 4-4 0-.6030539 0-1.9363872 0-4-1.79696123 0-3.13029457 0-4 0-2.209139 0-4 1.790861-4 4s1.790861 4 4 4z",
    fill: "#09cf83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 16h4v-8c-1.930287 0-3.26362033 0-4 0-2.209139 0-4 1.790861-4 4s1.790861 4 4 4z",
    fill: "#a259ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 8h4v-8c-1.930287 0-3.26362033 0-4 0-2.209139 0-4 1.790861-4 4s1.790861 4 4 4z",
    fill: "#f24e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 8h-4v-8h4c2.209139 0 4 1.790861 4 4s-1.790861 4-4 4z",
    fill: "#ff7262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.aa8b47f4f6e0492ecbf8bd8df5f2243f.svg";
export { ForwardRef as ReactComponent };